import { render, staticRenderFns } from "./delivery2.vue?vue&type=template&id=21f833bc&scoped=true&"
import script from "./delivery2.vue?vue&type=script&lang=js&"
export * from "./delivery2.vue?vue&type=script&lang=js&"
import style0 from "./delivery2.vue?vue&type=style&index=0&id=21f833bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f833bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
